<template>
  <section class="webinar-gallery">
    <v-container>
      <div class="row-gallery">
        <div class="col-12 col-sm-8 offset-sm-2">
          <rwl-heading
            h="2"
            class="title-show"
            v-html="$t('webinars.gallery_title')"></rwl-heading>
          <div class="webinar-gallery__content">
            <slot></slot>
          </div>
        </div>
        <div class="gallery-row">
          <div class="gallery-item-wrapper">
            <gallery-item @click="index=1" :showOverlay="true"
                          :src="PUBLIC_PATH + 'images/item_1.jpg'"></gallery-item>
          </div>
          <div class="gallery-item-wrapper">
            <gallery-item @click="index = 1" :showOverlay="true"
                          :src="PUBLIC_PATH + 'images/item_2.jpg'"></gallery-item>

          </div>
          <div class="gallery-item-wrapper">
            <gallery-item @click="index = 2" :showOverlay="true"
                          :src="PUBLIC_PATH + 'images/item_3.jpg'"></gallery-item>
          </div>
          <div class="gallery-item-wrapper">
            <gallery-item @showMore="clicker()" :showMore="true" @click="index = 3"
                          :src="PUBLIC_PATH + 'images/item_4.jpg'" :showMoreCount="images.length">

            </gallery-item>
          </div>
        </div>
        <div>
          <gallery-big :index="index" :images="images" @close="index = null"></gallery-big>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
  import { VContainer } from "./ui"
  import { RwlHeading } from "@rawlplug/rawlplug-design-components-library"
  import { GalleryItem } from "./gallery"
  import { GalleryBig } from "./gallery"

  export default {
    name: "WebinarGallery",
    components: { VContainer, RwlHeading, GalleryItem, GalleryBig },

    data() {
      const PUBLIC_PATH = process.env.VUE_APP_ASSETS_PATH;

      return {
        PUBLIC_PATH,
        images: [
          {
            /* title: 'foto',*/
            href: PUBLIC_PATH + 'images/item_1.jpg',
            type: 'image',
            /*description: this.$t('webinars.gallery_item_1_description'),*/
          },
          {
            /* title: 'foto',*/
            href: PUBLIC_PATH + 'images/item_2.jpg',
            type: 'image',
            /*description: this.$t('webinars.gallery_item_1_description'),*/
          },
          {
            /*title: 'foto',*/
            href: PUBLIC_PATH + 'images/item_3.jpg',
            type: 'image',
            /* description: this.$t('webinars.gallery_item_1_description'),*/
          },
          {
            /*title: 'foto',*/
            href: PUBLIC_PATH + 'images/item_4.jpg',
            type: 'image',
            /*description: this.$t('webinars.gallery_item_1_description'),*/
          },
          {
            /*title: 'foto',*/
            href: PUBLIC_PATH + 'images/item_5.jpg',
            type: 'image',
            /* description: this.$t('webinars.gallery_item_1_description'),*/
          },
        ],

        index: null,
        klik: false
      }
    },
    methods: {
      clicker: function () {
        this.klik = true
      }
    }

  }
</script>

<style lang="scss" scoped>
  @import "~@rawlplug/rawlplug-design-style-tokens/dist/scss/all";

  .webinar-gallery {
    .title-show {
      text-align: center;
    }

    padding-bottom: 100px;
  }

  .gallery-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .item-text {
    text-align: left;
    padding-top: 20px;

  }

  .gallery-item-wrapper {
    overflow: hidden;
  }

  .row-gallery {
    padding-top: 40px;
  }

  @media all and (min-width: $breakpoint-sm-min) {
    .gallery-row {
      height: 200px;
    }

    .gallery-item-wrapper {
      width: 45%;
    }
  }

  @media screen and (min-width: $breakpoint-md-min) {
    .gallery-item-wrapper {
      width: 23%;
    }
  }

</style>
